module.exports = require('./helpers/bundle-url').getBundleURL('cZoPv') + "logo.c51670a8.svg";